<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="save_loading || archive_loading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Contract
            </h2>
            <div class="pb-0">
                <v-form name="editForm" ref="editForm">

                    <div class="tw-flex tw-mb-2 tw-p-2">
                        <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">


                            <v-text-field
                                v-model="model_object.name"
                                :error-messages="errors?.name"
                                :rules="[rules.required]"
                                label="Name"
                                outlined
                                dense
                                clearable
                                hide-details="auto"
                            ></v-text-field>

                            <v-file-input
                                v-model="new_file_to_upload"
                                :error-messages="errors?.file"
                                label="File"
                                :hint="model_object.file ? model_object.file : ''"
                                outlined
                                dense
                                clearable
                                hide-details="auto"
                            ></v-file-input>

                            <v-select
                                v-model="model_object.status"
                                :items="valuelists.CONTRACT_STATUSES"
                                :error-messages="errors?.status"
                                :rules="[rules.required]"
                                label="Status"
                                outlined
                                dense
                                clearable
                                hide-details="auto"
                            ></v-select>

                            <v-select
                                v-model="model_object.contract_id"
                                :items="valuelists.CONTRACTS"
                                :error-messages="errors?.contract_id"
                                :rules="[rules.required]"
                                label="Type"
                                outlined
                                dense
                                clearable
                                hide-details="auto"
                            ></v-select>



                        </div>
                    </div>
                </v-form>
            </div>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3" >
                <v-btn
                    text
                    @click="archiveModel"
                    class="btn-solid"
                    :loading="archive_loading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="save_loading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>

export default {
    name: "EditProductionContractDialog",
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: false,
            default: function() {
                return false
            }
        },
        'model_prop': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: 'Add',
            model_object: {},
            model_default: {
                id: null,
                contract_id: null,
                status: null,
                file: null,
            },
            new_file_to_upload: null,
            errors: null,
            save_loading: false,
            archive_loading: false,
            rules: {
                required: value => !!value || 'Required',
            },

        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '460px'
        },
        is_edit_mode() {
            return this.mode == 'Edit'
        }
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        resetValidation () {
            if (this.$refs && this.$refs.editForm) {
                this.$refs.editForm.resetValidation()
            }
            this.errors = null
        },
        saveModel() {

            if (!this.$refs.editForm.validate()) {
                this.$root.snackbar.error('Please fill all required fields.')
                return false
            }

            let production_id = this.$parent?.production?.id
            if (!production_id) {
                this.$root.snackbar.error("Unable to locate production ID")
                return false
            }

            // let payload = this.model_object
            let payload = new FormData()
            payload.append("name", this.model_object.name)
            payload.append("contract_id", this.model_object.contract_id)
            payload.append("status", this.model_object.status)
            payload.append("production_id", production_id)

            if (!!this.new_file_to_upload){
                payload.append("file", this.new_file_to_upload)
            }

            let url = route('productioncontract.store')

            if (this.is_edit_mode) {
                url = route('productioncontract.update', this.model_object.id)
                // payload._method = "patch"
                payload.append("_method", "patch")
            }


            axios({
                method: 'post',
                url: url,
                data: payload,
                onUploadProgress: (evt) => {
                    this.save_loading = !this.save_loading
                },
                onDownloadProgress: (evt) => {
                    this.save_loading = !this.save_loading
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.is_dirty = false
                        this.$root.snackbar.success('Changes have been saved')
                        this.dialog = false
                        this.$root.is_dirty = false
                        this.save_loading = false
                        this.$emit('successful-save')
                    } else if (response.data?.error) {
                        throw (response.data?.error)
                    } else {
                        throw ('Unknown error.')
                    }
                })
                .catch((error) => {
                    if (error?.response) {
                        this.$root.snackbar.error(error.response.data.message)
                        this.errors = error.response?.data?.errors
                    } else {
                        console.log(error)
                        this.$root.snackbar.error(error)
                    }
                    this.save_loading = false
                })

        },
        async archiveModel()
        {
            if (await this.$root.confirm.open(`Delete Production Contract?`, `You are about to delete ${this.model_object.name}`)) {

                let method = 'delete'
                let url = route('productioncontract.destroy', this.model_object.id)
                let payload = this.model_object

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archive_loading = !this.archive_loading
                    },
                    onDownloadProgress: (evt) => {
                        this.archive_loading = !this.archive_loading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Production Contract has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archive_loading = false
                            this.$emit('successful-delete')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archive_loading = false
                    })
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            this.new_file_to_upload = null
            if (newDialog === false) {
                // Closing modal
                this.resetValidation()
            } else {
                // Opening modal
                this.resetValidation()
                if (this.model_prop === null) {
                    this.mode = 'Add'
                    this.$set(this, 'model_object', structuredClone(this.model_default))
                } else {
                    this.mode = 'Edit'
                    this.$set (this, 'model_object', structuredClone(this.model_prop))
                }
            }
        },
        model_object: {
            handler(newVal, oldVal) {
                    this.resetValidation()
            },
            deep: true,
        },
    },
}

</script>

<style scoped>

</style>
